export default function ThemeToggle() {
  return null;
}
